<template>
  <v-sheet>
    <v-card>
      <v-card-title><h2>Nowa akcja</h2></v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form">

            <v-select v-model="subscriberSelected" label="Rodzaj akcji"
                      :items="subscriberTypes"
                      @change="model={}"
                      item-text="description"
                      item-value="name"
            ></v-select>

            <v-select v-model="eventType" label="Wydarzenie"
                      v-if="subscriberSelected"
                      :items="EventActionType
                      .getEventsToSelect(subscriberTypes.find(el => el.name == subscriberSelected).properties.allowedEvents)"
                      item-text="name"
                      item-value="value"
            ></v-select>

            <div v-for="field in getActionFields(subscriberSelected)">
              <v-select v-model="model[field.name]"
                        v-if="field.type=='select'"
                        :label="field.description"
                        :items="field.options"
              ></v-select>

              <v-select v-model="model[field.name]"
                        v-else-if="field.type=='fieldOrder'"
                        :label="field.description"
                        :items="getFields()"
                        item-text="name"
                        item-value="order"
              ></v-select>

              <v-select v-model="model[field.name]"
                        v-else-if="field.type=='relatedFieldOrder'"
                        :label="field.description"
                        :items="getFields('related')"
                        item-text="name"
                        item-value="order"
              ></v-select>

              <v-checkbox v-model="model[field.name]"
                        v-else-if="field.type=='checkbox'"
                        :label="field.description"
              ></v-checkbox>

              <v-select v-model="model[field.name]"
                        v-else-if="field.type=='templateId'"
                        :label="field.description"
                        :items="templates"
                        item-text="name"
                        item-value="id"
              ></v-select>

              <v-text-field v-else :type="getInputType(field.type)" :label="field.description" v-model="model[field.name]"></v-text-field>
            </div>

            <v-btn @click="submit()">Ok</v-btn>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>
import eventActionType from "../../../enums/eventActionType";
export default {
  props: ['subscriberTypes', 'schema', 'templates'],
  data() {
    return {
      subscriberSelected: null,
      model:{},
      eventType: null,
      EventActionType: eventActionType
    }
  },
  computed: {
    fields() {
      let fields = []
      this.schemaFields.forEach(field => {
        fields.push(field)
        if (field['sub-fields'] != undefined) {
          field['sub-fields'].forEach(subField => fields.push(subField))
        }
      })
      return fields
    }
  },
  methods: {
    getFields(type){
      return this.schema.fields.filter(field => field.type != 'table' && type ? field.type==type : true )
    },
    getInputType(type){
      switch (type){
        case "integer" : return "number"
        case "relatedValueKey" : return "number"
        default : return "text"
      }
    },
    getActionPropertyDescription(actionType, propertyName){
      let action = this.subscriberTypes.find(el => el.name == actionType)
      let property = action ? action.properties.fields.find(el => el.name == propertyName) : null
      return property ? property.description : "Nieznana własciwość"
    },
    getActionFields(type){
      let action = this.subscriberTypes.find(el => el.name == type)
      return action ? action.properties.fields : []
    },
    submit() {
      if (!this.eventType || !this.subscriberSelected) {
        return
      }

      let postData = {
        'subscriber': this.subscriberSelected,
        'event': this.eventType,
        'data': this.model
      }
      this.$http.post(`schema/${this.$route.params.schemaId}/subscriber`, postData).then(data => {
        this.$emit('subscriberCreated',data.data)
        this.$store.commit('setSnack', {
          message: "Dodano akcje",
          color: 'success'
        })

        // this.$router.push({name: 'schema-related-map', params: {schemaId: this.$route.params.schemaId}})
      }).catch(() => {
        this.$store.commit('setSnack', {
          message: "Nie można dodać akcji",
          color: 'error'
        })
      })
    },
  },
}
</script>
